<template>
  <div>
    <PermissMana></PermissMana>
  </div>
</template>

<script>
import PermissMana from "../../components/sys/basic/PermissMana";
export default {
  name: "SysBasic",
  components: {
    PermissMana,
  },
};
</script>

<style scoped>
</style>